import {
	IconDefinition,
	faCircleExclamation,
	faCircleInfo,
	faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { ReviewSeverity } from "../../types/event";

/* Shared by the check's modal (EventReviewModal) and the sidebar's
   breakdown under "N issues found", so the two use the same icons and
   words. Its own file because a component file exporting constants breaks
   fast refresh. */

/**
 * Severity as an icon, not a badge. A word badge on every issue repeated
 * "Worth checking" down the list and pushed each title onto a second line in
 * the modal; the legend above the list says what each icon means once.
 *
 * Shape as well as colour, so the three still read apart without colour.
 */
export const SEVERITY: Record<
	ReviewSeverity,
	{ icon: IconDefinition; label: string }
> = {
	high: { icon: faCircleExclamation, label: "Important" },
	medium: { icon: faTriangleExclamation, label: "Worth checking" },
	low: { icon: faCircleInfo, label: "Minor" },
};

export const ORDER: ReviewSeverity[] = ["high", "medium", "low"];

/** An unknown severity from a newer API shows as Minor rather than crashing. */
export const severityOf = (s: string): ReviewSeverity =>
	s in SEVERITY ? (s as ReviewSeverity) : "low";
